import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export const PaysprintPanRedirectURL = () => {
    const formRef = useRef(null);
    const location = useLocation();
    const RedirectURL = location.state.RedirectURL;
    const initialValues = {
        RedirectURL: RedirectURL
    };

    const [FormObj, setFormObj] = useState(initialValues);

    useEffect(() => {
        setFormObj({
            RedirectURL: RedirectURL
        });
        formRef.current.submit();
    }, []);
    return (
        <form
            ref={formRef}
            id="form1"
            method="post"
            name="form1"
            action={FormObj.RedirectURL}
        >
            <textarea name="encdata" style={{ display: 'none' }}>
                {FormObj.EncData}
            </textarea>
            <input type="submit" value="Submit" />
        </form>
    );
};
